import type { BaseDataItem } from '@wix/thunderbolt-becky-types'
import type { RefInfo } from '@wix/document-services-types'
import _ from 'lodash'
import { createDataRef } from '../nodeFactory/dataNodeUtils'

export const createRefResolver = (
	getSchema: (mapName: string, type: string) => RefInfo[],
	excludedPathsByDataItemType: { [dataItemType: string]: Array<string> } = {},
) => (dataItem: BaseDataItem, mapName: string, namespace = 'data') => {
	const refs = getSchema(mapName, dataItem.type)
	if (!refs) {
		return null
	}

	return refs.reduce((acc, { path, referencedMap }) => {
		const referencedId = _.get(dataItem, path)
		if (!referencedId || excludedPathsByDataItemType[dataItem.type]?.includes(path.join('.'))) {
			return acc
		}

		const value = Array.isArray(referencedId)
			? referencedId.map((id) => createDataRef(namespace, referencedMap, id))
			: createDataRef(namespace, referencedMap, referencedId)

		_.set(acc, path, value)

		return acc
	}, {})
}
